import B2BApi from '../../../B2bApi';
import { useNavigate } from "react-router-dom";
// import {useSelector} from 'react-redux';
import { t } from '../../../content';

function Logout({children}) {
    const navigate = useNavigate();

    function logout() {
        let obj = new B2BApi();
        obj.logout();
        navigate("/");
        window.location.reload();
    }

    return (
            <span className="logout" onClick={logout}>{ children ? children : t('nav.items.logout') }</span>
        )
}

export default Logout